import { generateTestId } from "@client-shared";

export const setInventoryStatsTestId = (identifier: string): string =>
  generateTestId("InventoryStats", identifier);

// Specific testId setters for tests
export const setInventoryStatsContainerTestId = (): string =>
  setInventoryStatsTestId("container");
